import store from "@/store";
const month = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
const monthUTC = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(timezone);

export function updateTime(time) {
    let time_zone = dayjs(time);
    let offsetDate = new Date(dayjs.utc(time_zone)) + "";
    let today = new Date(dayjs.utc(dayjs())) + "";
    if (store.getters.timezone) {
        time_zone = dayjs(time).tz(store.getters.timezone);
        offsetDate = new Date(dayjs.utc(time_zone)) + "";
        today = dayjs().tz(store.getters.timezone);
        today = new Date(dayjs.utc(today)) + "";
    }
    let parsedToday = today.split(" ");
    let parsedTime = offsetDate.split(" ");
    let parsedTodayDate = parsedToday[1] + " " + parsedToday[2] + " " + parsedToday[3];
    let parsedTimeDate = parsedTime[1] + " " + parsedTime[2] + " " + parsedTime[3];
    let parsedYesterdayTime = parsedToday[2] - 1;
    parsedYesterdayTime = parsedYesterdayTime < 10 ? '0' + parsedYesterdayTime : parsedYesterdayTime;
    let parsedTimeDateYesterday = parsedToday[1] + " " + parsedYesterdayTime + " " + parsedToday[3];
    let parsedTomorrowTime = parsedToday[2] + 1;
    parsedTomorrowTime = parsedTomorrowTime < 10 ? '0' + parsedTomorrowTime : parsedTomorrowTime;
    let parsedTimeDateTomorrow = parsedToday[1] + " " + parsedTomorrowTime + " " + parsedToday[3];
    if (parsedTodayDate == parsedTimeDate) {
        return "сегодня в " + parsedTime[4].slice(0, 5);
    } else if (parsedTimeDateYesterday == parsedTimeDate) {
        return "вчера в " + parsedTime[4].slice(0, 5);
    } else if (parsedTimeDateTomorrow == parsedTimeDate) {
        return "завтра в " + parsedTime[4].slice(0, 5);
    }
    let dateStr = parsedTime[2] + "." + month[monthUTC.indexOf(parsedTime[1])] + "." + parsedTime[3];
    let timeStr = parsedTime[4].slice(0, 5);
    return dateStr + " в " + timeStr;
}

export function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    if ([',', '.', '-'].includes(evt.key)) {
        return evt;
    }
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode < 48 || charCode > 57) {
        return evt.preventDefault();
    } else {
        return evt;
    }
}

export function timeWithTZ(time) {
    return dayjs(time).format() + "";
}

export function timeToUTC(time) {
    let targetTime = new Date(time);
    let timeZoneFromDB = -1 * dayjs().utcOffset();
    let tzDifference = timeZoneFromDB + targetTime.getTimezoneOffset();
    let offsetTime = new Date(targetTime.getTime() + tzDifference * 60 * 1000);
    let date = dayjs(offsetTime).format();
    return date.slice(0, 19) + "Z";
}

export function getTimeFromDate(time) {
    let parsedTime = time.split(" ");
    let timeStr = parsedTime[1].slice(0, 5);
    return "в " + timeStr;
}